import React, { useEffect, useState } from 'react';
import { db } from '../../config/firebase.js';
import { collection, onSnapshot } from 'firebase/firestore';
import UserTable from './UserTable';
import GoogleAnalytics from '../../analyticsComponents/GoogleAnalytics.js';

const STANDARD_ROLES = ['open access user', 'educator', 'moderator', 'admin'];

const RoleAssignPage = () => {
  const [users, setUsers] = useState([]);
  const [roles, setRoles] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [showNewUsers, setShowNewUsers] = useState(false);
  const [modifiedUsers, setModifiedUsers] = useState({});

  useEffect(() => {
    const unsubscribe = onSnapshot(collection(db, 'users'), (snapshot) => {
      const userList = snapshot.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
      }));

      // Offer every application role, even ones nobody holds yet
      const roleList = [...STANDARD_ROLES, ...userList.map((u) => u.role).filter(Boolean)];
      setUsers(userList);
      setRoles([...new Set(roleList)]);
    });

    return () => unsubscribe();
  }, []);

  const handleRoleChange = (id, role) =>
    setModifiedUsers((prev) => ({ ...prev, [id]: role }));

  const handleShowNewUsers = () => setShowNewUsers((prev) => !prev);

  const filteredUsers = users.filter((u) =>
    u.email.toLowerCase().includes(searchQuery.toLowerCase()) ||
    u.full_name?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const displayedUsers = showNewUsers
    ? filteredUsers.filter(u => u.role === 'open access user' && u.requested_role === 'educator')
    : filteredUsers;

  return (
    <div className="user-list-page max-w-6xl mx-auto px-4 sm:px-6 lg:px-6 py-8">
      <GoogleAnalytics page="RoleAssignPage" eventType="roleAssign_page"/>

      {/* Header */}
      <div className="mb-6">
        <div className="flex items-center gap-3">
          <span className="inline-block px-2.5 py-0.5 rounded-full bg-blue-100 text-blue-700 text-xs font-semibold">Admin</span>
          <h1 className="text-2xl font-bold text-gray-900">Assign Roles</h1>
        </div>
        <p className="mt-1 text-sm text-gray-500">Search for users and update their roles. Filter to review new users requesting educator access.</p>
      </div>

      <div className="flex flex-wrap items-center gap-4 mb-6">
        <h2 className="text-xl font-semibold text-gray-800">User List</h2>

        <input
          type="text"
          placeholder="Search by email or name"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="flex-1 min-w-[220px] p-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-sky-400"
        />

        <button
          onClick={handleShowNewUsers}
          className="px-4 py-2 text-sm font-medium bg-sky-400 text-white rounded-md hover:bg-sky-500 transition"
        >
          {showNewUsers ? 'Show All Users' : 'Show New Users'}
        </button>
      </div>

      <UserTable
        users={displayedUsers}
        roles={roles}
        modifiedUsers={modifiedUsers}
        onRoleChange={handleRoleChange}
        setModifiedUsers={setModifiedUsers}
      />
    </div>
  );
};

export default RoleAssignPage;
